import React, { Fragment, useEffect, useState } from 'react'

import FriendLabel, { YourLabel } from './FriendLabel'
import ReactTooltip from 'react-tooltip'
import classnames from 'classnames'
export const UnderFiveFriends = ({ friendsCount }) => (
  <div className="row center-xs piggybankNeedFriends">
    Invite {friendsCount === 0 ? 5 : 5 - friendsCount} more{' '}
    {friendsCount === 4 ? 'friend' : 'friends'} to start earning.
  </div>
)

export const OverFiveFriendsNoOrder = ({
  friendsOrderCount,
  friendsCount,
  avatarId,
  isWebpSupported,
}) => (
  <div className="row center-xs">
    <FriendCircles
      avatarId={avatarId}
      classNames={{ youLabelEmpty: true }}
      friendsOrderCount={friendsOrderCount}
      isWebpSupported={isWebpSupported}
    />
    {friendsCount >= 5 && (
      <div className="col-xs-12 center-xs piggybankFriends">
        {friendsOrderCount.length >= 5
          ? 'Almost there! Place your order to earn $1.'
          : `You and ${5 - friendsOrderCount.length} more ${
              friendsOrderCount.length === 4 ? 'friend needs' : 'friends need'
            } to order.`}
      </div>
    )}
  </div>
)

export const OverFiveFriendsWithOrder = ({
  friendsOrderCount,
  friendsCount,
  avatarId,
  isWebpSupported,
}) => (
  <div className="row center-xs">
    <FriendCircles
      avatarId={avatarId}
      classNames={{ youLabelColored: true }}
      friendsOrderCount={friendsOrderCount}
      isWebpSupported={isWebpSupported}
    />
    {friendsCount >= 5 && friendsOrderCount.length < 5 ? (
      <div className="col-xs-12 center-xs piggybankFriends">
        {5 - friendsOrderCount.length} more{' '}
        {friendsOrderCount.length === 4 ? 'friend needs' : 'friends need'} to
        order.
      </div>
    ) : (
      friendsCount >= 5 && (
        <div className="col-xs-12 center-xs piggybankFriends">
          You will receive $1 when your food arrives.
        </div>
      )
    )}
  </div>
)

export const PiggyBankSuccess = ({
  friendsOrderCount,
  avatarId,
  isWebpSupported,
}) => (
  <div className="row center-xs">
    <FriendCircles
      avatarId={avatarId}
      classNames={{ youLabelColored: true }}
      friendsOrderCount={friendsOrderCount}
      isWebpSupported={isWebpSupported}
      piggyBankSuccess
    />
    <div className="col-xs-12 center-xs piggybankFriends">
      $1 has been added to your credit balance!
    </div>
  </div>
)

export const FriendCircles = ({
  friendsOrderCount,
  classNames,
  piggyBankSuccess,
  avatarId,
  isWebpSupported,
}) => (
  <Fragment>
    <YourLabel
      avatarId={avatarId}
      classNames={classNames}
      isWebpSupported={isWebpSupported}
      style={{ letterSpacing: '-1px' }}
    />{' '}
    <span className="piggyBankPlusEquals">+</span>
    {friendsOrderCount &&
      friendsOrderCount.slice(0, 5).map((friend, i) => (
        <div className="circleContainer" key={i}>
          <div className="labelOuter">
            <FriendLabel
              avatarId={friend.avatarId}
              classNames={{ piggybankColoredCircle: true }}
              email={friend.email}
              firstName={friend.firstName}
              isWebpSupported={isWebpSupported}
              lastName={friend.lastName}
              showEmail={false}
              showName={false}
              size="small"
            />
          </div>
          <div className="creditsProgressBarShort creditsProgressBarColor" />
        </div>
      ))}
    {friendsOrderCount.length <= 5 &&
      [...Array(5 - friendsOrderCount.length)].map((x, i) => (
        <div className="circleContainer" key={i}>
          <div className="labelOuter">
            <div className="piggybankEmptyCircle" />
          </div>
          <div className="creditsProgressBarShort" />
        </div>
      ))}
    <div className="circleContainer">
      <span className="piggyBankPlusEquals">=</span>
      <span className="piggyBankDollar">$1.00</span>
      <div
        className={classnames({
          creditsProgressBarLong: true,
          rightRadius: true,
          creditsProgressBarColor: piggyBankSuccess,
        })}
      />
    </div>
  </Fragment>
)

const PiggyBank = ({
  friendsOrderCount = [],
  orders,
  friends = [],
  activeOrders,
  hideOrderStatus,
  titleText,
  locationId,
  friendsAtOrderDelivered = [],
  loadFriendsAtDateTimeStart,
  selectedDate,
  profile,
  isWebpSupported,
}) => {
  const [currentDate, setCurrentDate] = useState(undefined)
  const [
    friendsAtOrderDeliveredCount,
    setFriendsAtOrderDeliveredCount,
  ] = useState([])

  useEffect(() => {
    if (selectedDate && currentDate !== selectedDate) {
      setCurrentDate(selectedDate)
    }
  }, [currentDate, selectedDate])

  useEffect(() => {
    const deliveredOrder = orders.find(order => order.deliveredDateTime)
    if (
      currentDate &&
      deliveredOrder &&
      friends.length > 0 &&
      friendsAtOrderDelivered.length === 0
    ) {
      loadFriendsAtDateTimeStart(deliveredOrder.deliveredDateTime)
    }
  }, [
    currentDate,
    friends.length,
    friendsAtOrderDelivered.length,
    loadFriendsAtDateTimeStart,
    orders,
  ])

  useEffect(() => {
    if (
      friendsOrderCount &&
      friendsOrderCount.length > 0 &&
      friendsAtOrderDelivered &&
      friendsAtOrderDelivered.length > 0
    ) {
      const friends = friendsOrderCount.filter(order =>
        friendsAtOrderDelivered.includes(order.userId),
      )
      setFriendsAtOrderDeliveredCount(friends || [])
    }
  }, [friendsAtOrderDelivered, friendsOrderCount])

  return (
    <div
      className={classnames({
        piggybankContainer: true,
        piggybankConfirmation: hideOrderStatus,
      })}
    >
      <div
        data-for="piggy-bank-info"
        data-tip={
          'Earn a $1 credit off your next meal when you and 5 coworkers order today. '
        }
      >
        <ReactTooltip
          className="foodsby-tooltip"
          delayHide={0}
          delayShow={500}
          delayUpdate={0}
          effect="float"
          id="piggy-bank-info"
          offset={{ top: 5, right: 0 }}
          place="bottom"
        />
        <div className="center-xs piggybankHeader">
          {titleText || 'Earn Credit Daily'}
          <i
            className="icon-info-circle"
            style={{
              paddingLeft: '8px',
              fontSize: '12px',
              verticalAlign: 'text-top',
            }}
          ></i>
        </div>
      </div>
      {orders.length === 0 ||
      (orders.length > 0 && activeOrders.length === 0) ? (
        <OverFiveFriendsNoOrder
          {...{
            friendsOrderCount,
            friendsCount: friends.length,
            avatarId: profile && profile.avatarId,
            isWebpSupported,
          }}
        />
      ) : orders.find(order => order.isDelivered === true) &&
        friendsAtOrderDeliveredCount.length >= 5 ? (
        <PiggyBankSuccess
          {...{
            friendsOrderCount: friendsAtOrderDeliveredCount,
            avatarId: profile && profile.avatarId,
            isWebpSupported,
          }}
        />
      ) : (
        orders.length > 0 && (
          <OverFiveFriendsWithOrder
            {...{
              friendsOrderCount:
                friendsAtOrderDeliveredCount.length > 0
                  ? friendsAtOrderDeliveredCount
                  : friendsOrderCount,
              friendsCount: friends.length,
              avatarId: profile && profile.avatarId,
              isWebpSupported,
            }}
          />
        )
      )}
      {friends.length < 5 && (
        <UnderFiveFriends {...{ friendsCount: friends.length }} />
      )}
    </div>
  )
}

export default PiggyBank
